import pdf from 'images/icons/pdf.svg';
import { Button } from 'components/buttons/Button/Button';
import './styles.scss';

const PDFCard = ({data}) => {
    return (
        <div className="pdf-card">
            <div className="pdf-card__top">
                <img src={pdf} alt="pdf" />
                <div className="pdf-card__top__right-icons">
                    <Button type="view" />
                    <Button type="download"/>
                </div>
            </div>
            <p className="body2">{data.title}</p>
        </div>
    );
};

export default PDFCard;
